import { TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  value: string
  onChange: (value: string) => void
}

export const VisibilityToggler = ({ value, onChange }: Props) => {
  return (
    <TogglerCheckbox
      value={value === 'restricted'}
      label={i18n.t('ats.feedbacks.restricted_comment.label')}
      onChange={() => onChange(value === 'restricted' ? 'public' : 'restricted')}
      information={i18n.t('ats.feedbacks.restricted_comment.tooltip')}
    />
  )
}
